export default __webpack_public_path__ + "static/media/Calendar.3dbb1f42.svg";